import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import PromoBanner from "./PromoBanner";
import { SeasonalStrip, SeasonalPreviewBar } from "@/lib/seasonal";
import Footer from "./Footer";
import api from "@/lib/api";
import { visitorCountry } from "@/lib/geo";

const SESSION_KEY = "rf_visit_logged_v1";

async function trackVisitOnce() {
  if (typeof window === "undefined") return;
  // Only once per browser session
  if (sessionStorage.getItem(SESSION_KEY)) return;
  sessionStorage.setItem(SESSION_KEY, "1");
  const country = (await visitorCountry()) || "UNKNOWN";
  try {
    await api.post("/analytics/track", { country, path: window.location.pathname });
  } catch {}
}

export default function Layout({ children }) {
  useEffect(() => { trackVisitOnce(); }, []);
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen flex flex-col bg-rf-cream">
      {/* WCAG 2.1 — skip-to-content link for keyboard & screen-reader users */}
      <a href="#main-content" className="skip-link" data-testid="skip-to-content">Skip to main content</a>
      <SeasonalPreviewBar />
      <PromoBanner />
      <Header />
      <SeasonalStrip pathname={pathname} />
      <main id="main-content" tabIndex={-1} className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
